import type { ServerCartItem } from '../types/api';
import type { CartItem, Product } from '../types';
import { slugify } from './product';

export function serverCartItemToProduct(item: ServerCartItem): Product {
  return {
    id: item.productId,
    slug: slugify(item.productName) || `urun-${item.productId}`,
    name: item.productName,
    description: '',
    price: item.unitPrice,
    effectivePrice: item.unitPrice,
    currency: item.currency === 'TRY' ? 'TRY' : 'EUR',
    category: '',
    images: item.productImage ? [item.productImage] : [],
    benefits: [],
    stock: item.stock,
    inStock: item.inStock,
  };
}

export function serverCartToItems(cartItems: ServerCartItem[]): CartItem[] {
  return cartItems.map((item) => ({
    product: serverCartItemToProduct(item),
    quantity: item.quantity,
  }));
}

export function cartItemsToUpdateRequest(items: CartItem[]) {
  return items.map(({ product, quantity }) => ({
    productId: product.id,
    quantity,
  }));
}

export function mergeCartItems(local: CartItem[], server: CartItem[]): CartItem[] {
  const merged = new Map<number, CartItem>();

  for (const item of server) {
    merged.set(item.product.id, item);
  }

  for (const item of local) {
    const existing = merged.get(item.product.id);
    if (!existing) {
      merged.set(item.product.id, item);
      continue;
    }

    merged.set(item.product.id, {
      product: item.product,
      quantity: Math.max(item.quantity, existing.quantity),
    });
  }

  return Array.from(merged.values());
}

export function cartItemCount(items: CartItem[]): number {
  return items.reduce((sum, item) => sum + item.quantity, 0);
}
